<template>
  <div class="home">
    <Slider :sliders="sliders"></Slider>
    <FeaturedProducts :mainProduct="mainProduct" :products="products"></FeaturedProducts>
    <Seasonal></Seasonal>
    <About></About>
    <Chocolates :chocolates="chocolates"></Chocolates>
    <FeaturedPost :post="post"></FeaturedPost>
    <Social :igImages="igImages"></Social>
    <ContactUs></ContactUs>
  </div>
</template>

<script>
import axios from "axios";
import About from "@/components/home/About.vue";
import Slider from "@/components/home/Slider.vue";
import Seasonal from "@/components/home/Seasonal.vue";
import ContactUs from "@/components/home/ContactUs.vue";
import Chocolates from "@/components/home/Chocolates.vue";
import FeaturedPost from "@/components/home/FeaturedPost.vue";
import Social from "@/components/home/Social.vue";
import FeaturedProducts from "@/components/home/FeaturedProducts.vue";

export default {
  name: "Home",
  components: {
    About,
    Slider,
    Seasonal,
    ContactUs,
    Chocolates,
    FeaturedPost,
    Social,
    FeaturedProducts
  },
  data() {
    return {
      sliders: undefined,
      mainProduct: undefined,
      products: undefined,
      chocolates: undefined,
      post: undefined,
      igImages: undefined
    };
  },
  mounted() {
    this.getHomepage();
  },
  methods: {
    getHomepage() {
      axios.get("/homepage").then(response => {
        this.sliders = response.data.sliders;
        this.mainProduct = response.data.featuredProducts.shift();
        this.products = response.data.featuredProducts;
        this.chocolates = response.data.featuredChocolates;
        this.post = response.data.featuredPost;
        this.igImages = response.data.instaFeed;
      });
    }
  }
};
</script>
